import React, {useState} from "react";
import {Links} from "../../gen/api";
import {List, ListItem} from "@mui/material";
import DeleteButton from "../DeleteButton/DeleteButton";
import ActionDialog from "../ActionDialog/ActionDialog";
import FormLink from "./FormLink";
import NewLinkAdd from "./NewLinkAdd";

type Props = {
    links: Links[]

    handleNewLinkSubmit: (links: Links) => void
    handleDeleteLink: (links: Links) => void
}

function LinksEdit({
                            links,
                            handleNewLinkSubmit,
                            handleDeleteLink
                      }: Props) {
  const [deleteLinkModalOpen, setDeleteLinkModalOpen] = useState(false);
  const [link, setLink] = useState<Links>();

  function deleteLink(link?: Links) {
    if (link) handleDeleteLink(link);
    setDeleteLinkModalOpen(false);
  }

  return (
      <>
          <List>
            {links.map((link: Links) => (
                <ListItem key={link.formName}>
                  <FormLink link={link}/>
                  <DeleteButton onClick={_ => {
                    setLink(link);
                    setDeleteLinkModalOpen(true);
                  }}/>
                </ListItem>
            ))}
            <ListItem>
              <NewLinkAdd handleNewLinkSubmit={handleNewLinkSubmit}/>
            </ListItem>
          </List>
        <ActionDialog isOpen={deleteLinkModalOpen}
                      onConfirm={() => deleteLink(link)}
                      onClose={() => setDeleteLinkModalOpen(false)}
                      title="Link löschen"
                      message="Möchten Sie den Link wirklich löschen?"/>
      </>
  );
}

export default LinksEdit;